import React from 'react';
import { connect } from 'react-redux';
import { toggleSaveSystemSetting } from './../reducer';
import { compose } from 'redux';
import SimpleTooltip from '../../../common/tooltip/SimpleTooltip';

class SaveSystemSetting extends React.Component {
  loadSystemSetting = () => {
    const { toggleSaveSystemSetting } = this.props;
    toggleSaveSystemSetting();
  };

  render() {
    return (
      <li onClick={this.loadSystemSetting}>
        <SimpleTooltip
          message={'layout.tooltipSideBar.GENERAL_SETTING'}
          position={'right'}
          isI18n={true}
          appendClassName={'d-block'}
          appendStyle={{ zIndex: 99999 }}
        >
          <a href="#">
            <i className="icon-settings" />
          </a>
        </SimpleTooltip>
      </li>
    );
  }
}

const mapDispatchToProps = {
  toggleSaveSystemSetting,
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
)(SaveSystemSetting);
